export default __webpack_public_path__ + "static/media/file-upload-sizes.f4a45d82.svg";